let initialized = false;

export const captureOnseasonEvent = (eventName, properties = {}) => {
  window.posthog?.capture?.(eventName, properties);
};

export const initializeOnseasonAnalytics = () => {
  if (initialized) return;
  initialized = true;

  document.addEventListener('click', event => {
    const target = event.target.closest?.('[data-onseason-event]');
    if (!target) return;

    captureOnseasonEvent(target.dataset.onseasonEvent, {
      path: window.location.pathname,
    });
  });
};
